/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './resetPassword.defs.js'
export { main as default } from './resetPassword.defs.js'
